import * as Popover from '@/components/ui/popover'
import type { TooltipProps } from '@/components/ui/tooltip'
import { debounce } from '@solid-primitives/scheduled'
import { type JSX, type ParentProps, createSignal } from 'solid-js'
import { Portal } from 'solid-js/web'

export const AppTooltip = (
  props: ParentProps<TooltipProps & { content: JSX.Element; className?: string, delay?: number, contentClass?: string }>,
) => {
  const { content, children, className, delay, contentClass, ...rest } = props
  const [isOpen, setIsOpen] = createSignal(false)

  const setIsOpenDebounced = debounce(setIsOpen, (delay || 100))

  return (
    <Popover.Root
      positioning={{
        fitViewport: true,
        placement: 'top',
      }}
      {...rest}
      open={isOpen()}
    >
      <Popover.Anchor
        class={className}
        onMouseLeave={() => setIsOpenDebounced(false)}
        onMouseEnter={() => setIsOpenDebounced(!isOpen())}
      >
        {props.children}
      </Popover.Anchor>
      <Portal>
        <Popover.Positioner zIndex={isOpen() ? '9999!important' : ''}>
          <Popover.Content
            outline="none"
            fontSize="xs"
            p="2"
            width="max-content"  // Forces the container to hug the content
            maxWidth="xs"        // Optional: Ensures very long text still wraps nicely (e.g., 20rem or 320px)
            class={contentClass}
          >
            {props.content}
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  )
}
